<!--
/*******************************************************************************
*@ 컴포넌트명   : mmrManagePayees.vue
*@ 컴포넌트설명 : 미얀마 타행 자주쓰는계좌등록
*@ 사용전문     : RBF0408W40 - 현지은행목록조회
                 RBF0600C60 - 입출금계좌등록
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="scroll">
    <article class="contents">
      <div class="form">
        <div class="form-row">
          <select-box
            ref="ovsesSendBnkRefno"
            :value.sync="ovsesSendBnkRefno"
            :option-list="bankList"
            label-i18n="MPRS-02-02-09-02"
            @selected="selected"
            required
          />
        </div>
        <div class="form-row">
          <input-text
            ref="inquryAcno"
            id="inquryAcno"
            :value.sync="inquryAcno"
            labelI18n="MPRS-02-02-09-04"
            placeholder="MPRS-02-02-09-04"
            required
            :maxByte="20"
            alphaNum
          />
          <div class="info info-etc" v-html="$t('MPRS-02-02-09-12', { 1: cncycd })"></div>
        </div>
        <div class="form-row" v-if="showLcalBnkBrnEngName == true">
          <div class="item-tit">
            {{ /*지점명*/ $t("MPRS-02-02-10-06") }}
            <sup class="point">*</sup>
          </div>
          <div class="item-desc">
            <div class="form-text-field search">
              <div class="input-text-field">
                <input
                  type="text"
                  id="lcalBnkBrnEngName"
                  class="form-control"
                  placeholder
                  disabled
                  :value.sync="lcalBnkBrnEngName"
                />
                <button
                  class="btn sm inline search"
                  @click="popupOpen"
                >{{ /*조회*/ $t("MPRS-02-02-13-06") }}</button>
              </div>
            </div>
            <div
              class="validate"
              v-if="lcalBnkBrnEngNameVal == true && lcalBnkBrnEngName == ''"
            >{{ /*필수 항목입니다.*/ $t("validations.required") }}</div>
          </div>
        </div>
        <div class="form-row">
          <input-text
            ref="inquryDpstrName"
            id="inquryDpstrName"
            :value.sync="inquryDpstrName"
            labelI18n="MPRS-02-02-19-05"
            placeholder="MPRS-02-02-19-06"
            required
            :maxByte="70"
            localeCase3
          />
          <!-- <div class="info info-etc" v-if="usePage == 'manage'">※ {{ $t("MPRS-02-02-10-14") }}</div> -->
        </div>
        <div class="form-row" v-if="usePage == 'manage'">
          <input-text
            ref="inquryAcnAls"
            id="inquryAcnAls"
            :value.sync="inquryAcnAls"
            labelI18n="MPRS-02-02-19-07"
            placeholder="MPRS-02-02-19-08"
            required
            :maxByte="40"
            engCase6
          />
          <!-- <div class="info info-etc">※ {{ $t("MPRS-02-02-10-15") }}</div> -->
        </div>
      </div>

      <popup
        :opened.sync="popupShow"
        :use-footer="false"
        :allScroll="true"
        title="MPRS-02-02-13-01"
      >
        <template #content>
          <div class="form-search top">
            <div class="form-row">
              <div class="item-tit">
                {{ bnkEngName }} ({{ ovsesSendBnkRefno }})
                <i
                  class="icon icon-fillter"
                  @click="fillter = !fillter"
                />
              </div>
              <div class="item-desc" v-if="fillter">
                <radio-box
                  id="searchBox"
                  ref="searchBox"
                  :data-list="radioList"
                  :value.sync="checkedRadioValue"
                  :is-horizontal="true"
                />
                <input-text
                  id="searchWord"
                  :value.sync="searchWord"
                  placeholder="MPAY-02-01-10-07"
                  toLowerCase
                  :maxByte="40"
                />
              </div>
            </div>
            <div class="form-row" v-if="fillter">
              <button class="btn lg normal" @click="search">{{ /*조회*/ $t("MPRS-02-02-13-06") }}</button>
            </div>
          </div>
          <common-grid2
            ref="commonGrid2"
            :list="popupRBF0408W40.response.grid"
            :totalCss="['total-count', 'no-border']"
            :scroll-event="true"
            :tagType="'div'"
            v-show="showGrid"
          >
            <template v-slot:list="data">
              <div class="box-white -type4">
                <div class="header" @click="popupClose(data.row)">
                  <div class="title">
                    {{ data.row.lcalBnkBrnNo }}
                    <i class="icon icon-arrow-m-right" />
                  </div>
                </div>
                <div class="content">
                  <div
                    class="item"
                  >{{ /*지점*/ $t("MPRS-02-02-18-03") }} : {{ data.row.lcalBnkBrnEngName }}</div>
                  <div
                    class="item"
                  >{{ /*주소*/ $t("MPRS-02-02-14-03") }} : {{ data.row.lcalBnkAddrCtnt1 }}</div>
                </div>
              </div>
            </template>
          </common-grid2>
        </template>
        <!-- <template #footer>
          <div class="btn-area--full">
            <button class="btn md normal" @click="popupClose()">{{ /*닫기*/ $t("MPRS-02-02-03-02") }}</button>
          </div>
        </template>-->
      </popup>
      <action-sheet
        :opened.sync="openSheet"
        :actionHeader="true"
        :actionFooter="true"
        :useTopBorder="true"
        title="MPRS-02-02-11-01"
        class="action-sheet"
      >
        <template #content>
          <div class="form-confirm">
            <div class="form-row">
              <div class="item-tit">{{ /*입금계좌번호*/ $t("MPAY-02-01-26-08") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ inquryAcno }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="item-tit">{{ /*은행명*/ $t("MPRS-02-02-02-05") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ bnkEngName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="item-tit">{{ /*지점명*/ $t("MPRS-02-02-02-06") }}</div>
              <div class="item-desc">
                <div class="form-text-field">{{ sheetLcalBnkBrnEngName }}</div>
              </div>
            </div>
          </div>
          <strong class="info-question">{{ /*입력하신 계좌와 지점명이 맞습니까?*/ $t("MPRS-02-02-11-05") }}</strong>
        </template>
        <template #footer>
          <button class="btn bottom negative" @click="cancel()">{{ /*아니오*/ $t("MPRS-02-02-11-06") }}</button>
          <button class="btn bottom positive" @click="confirm()">{{ /*예*/ $t("MPRS-02-02-11-07") }}</button>
        </template>
      </action-sheet>
      <action-sheet
        :opened.sync="mmrConfirm"
        :actionHeader="true"
        :actionFooter="true"
        :useTopBorder="true"
        title="MPRS-02-02-12-01"
        class="action-sheet"
      >
        <template #content>
          <strong class="info-question nomargin-top" v-html="$t('MPRS-02-02-12-05')">
            <!-- 입금 계좌에 해당하는 지점을 찾을 수 없습니다.
            <br />계좌번호를 다시 확인해 주시기 바랍니다.-->
          </strong>
        </template>
        <template #footer>
          <button
            class="btn bottom positive"
            @click="mmrConfirm = !mmrConfirm"
          >{{ /*확인*/ $t("MPRS-02-02-12-04") }}</button>
        </template>
      </action-sheet>
      <modal-pop :opened.sync="modalOpend" confirm="MCOM-0000003">
        <template #content>{{ $t("MPRS-02-02-12-06") }}</template>
      </modal-pop>
      <div class="btn-area--full fixed">
        <button class="btn md gray" @click="goToPrev()">{{ /*뒤로*/ $t("MPRS-02-02-15-12") }}</button>
        <button
          class="btn md normal"
          @click="goToNext()"
          :class="prgsYN"
        >{{ /*다음*/ $t("MPRS-02-02-15-13") }}</button>
      </div>
    </article>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CommonGrid2 from "@/components/page/common/CommonGrid2";

export default {
  components: {
    CommonGrid2,
  },
  computed: {
    ...mapFields(["sessionInfo"]),
  },
  watch: {
    ovsesSendBnkRefno: function () {
      this.validPrgs();
    },
    inquryAcno: function () {
      this.validPrgs();
    },
    lcalBnkBrnEngName: function () {
      this.validPrgs();
    },
    inquryDpstrName: function () {
      this.validPrgs();
    },
    inquryAcnAls: function () {
      this.validPrgs();
    },
  },
  props: {
    usePage: {
      type: String,
    },
    cncycd: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.RBF0408W40Call();
    this.brnBnkList = this.$getBnkBrnNo().MM2.ruleSet;
  },
  data() {
    return {
      lcalBnkBrnEngNameVal: false,
      modalOpend: false,
      scrollPosition: 0,
      checkedRadioValue: "1",
      mmrConfirm: false,
      radioList: [
        {
          value: "1",
          text: "MPRS-02-02-13-03", //지점명
        },
        {
          value: "2",
          text: "MPRS-02-02-13-04", //지점번호
        },
      ],
      fillter: true,
      searchWord: "",
      openSheet: false, //sheet open
      showGrid: false, //grid open
      page: 1,
      popupShow: false, //popup open
      ovsesSendBnkRefno: "", //해외송신은행참조번호
      lcalBnkBrnEngName: "", //현지은행부점번호
      bnkEngName: "", //은행영문명
      bnkShtenName: "", //은행단축명
      lcalBnkBrnNo: "", //BO현지은행번호
      ovsesSendBnkNo: "", //해외송신은행번호
      inquryAcno: "", //계좌번호
      inquryDpstrName: "", //예금주명
      inquryAcnAls: "",
      sheetLcalBnkBrnEngName: "", //sheet에 출력되는 현지은행부점번호
      bankList: [], //은행 리스트
      RBF0408W40: {
        request: {},
        response: {},
      },
      popupRBF0408W40: {
        request: {},
        response: {},
      },
      RBF0600C60: {
        request: {},
        response: {},
      },
      searchData: {},
      popupData: {
        ovsesSendBnkRefno: "",
        bnkShtenName: "",
        bnkEngName: "",
        inquryAcno: "",
      },
      mnrcvInfo: {
        mnrcvAcnAls: "",
        mnrcvAcno: "",
        mnrcvCncycd: "",
        mnrcvDpstrName: "",
        mnrcvOthrBnkName: "",
        mnrcvSerno: "",
        rcevnBnkIfscCode: "",
        mnrcvBrnName: "",
      },
      lcalBnkAcnoInfo: {},
      dataGrid: [],
      call: true,
      validList: [],
      searchType: "searchBox",
      prgsYN: "disabled",
      lcalBnkBrnEngNameYN: "",
      showLcalBnkBrnEngName: false,
      brnBnkList: [],
    };
  },
  methods: {
    validPrgs() {
      if (this.showLcalBnkBrnEngName == true) {
        if (this.lcalBnkBrnEngName == "") {
          this.lcalBnkBrnEngNameYN = true;
        } else {
          this.lcalBnkBrnEngNameYN = false;
        }
        if (this.usePage == "manage") {
          if (this.$refs.ovsesSendBnkRefno != undefined && this.$refs.inquryAcno != undefined && this.$refs.inquryDpstrName != undefined && this.$refs.inquryAcnAls != undefined) {
            this.prgsYN =
              this.$refs.ovsesSendBnkRefno.$v.$invalid ||
              this.$refs.inquryAcno.$v.$invalid ||
              this.$refs.inquryDpstrName.$v.$invalid ||
              this.$refs.inquryAcnAls.$v.$invalid ||
              this.lcalBnkBrnEngNameYN
                ? "disabled"
                : "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          } else {
            this.prgsYN = "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          }
        } else {
          if (this.$refs.ovsesSendBnkRefno != undefined && this.$refs.inquryAcno != undefined && this.$refs.inquryDpstrName != undefined) {
            this.prgsYN =
              this.$refs.ovsesSendBnkRefno.$v.$invalid || this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.lcalBnkBrnEngNameYN ? "disabled" : "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          } else {
            this.prgsYN = "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          }
        }
      } else {
        if (this.usePage == "manage") {
          if (this.$refs.ovsesSendBnkRefno != undefined && this.$refs.inquryAcno != undefined && this.$refs.inquryDpstrName != undefined && this.$refs.inquryAcnAls != undefined) {
            this.prgsYN =
              this.$refs.ovsesSendBnkRefno.$v.$invalid || this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.inquryAcnAls.$v.$invalid
                ? "disabled"
                : "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          } else {
            this.prgsYN = "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          }
        } else {
          if (this.$refs.ovsesSendBnkRefno != undefined && this.$refs.inquryAcno != undefined && this.$refs.inquryDpstrName != undefined) {
            this.prgsYN = this.$refs.ovsesSendBnkRefno.$v.$invalid || this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid ? "disabled" : "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          } else {
            this.prgsYN = "";
            this.$EventBus.$emit("mmrRegister", this.prgsYN);
          }
        }
      }
    },
    // valid1() {
    //   if (this.$refs.inquryAcnAls != undefined) {
    //     if (this.usePage == "manage") {
    //       if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryAcnAls.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.ovsesSendBnkRefno.$v.$invalid) {
    //         return "disabled";
    //       }
    //       return "";
    //     } else {
    //       if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.ovsesSendBnkRefno.$v.$invalid) {
    //         return "disabled";
    //       } else {
    //         return "";
    //       }
    //     }
    //   } else {
    //     return "disabled";
    //   }
    // },
    selected(text, data) {
      this.showLcalBnkBrnEngName = false;
      this.bankFullNm = text;
      this.bnkEngName = data;

      this.lcalBnkBrnEngName = "";
      this.bnkShtenName = "";
      this.ovsesSendBnkNo = "";
      this.lcalBnkBrnNo = "";
      this.inquryAcno = "";
      this.sheetLcalBnkBrnEngName = "";

      for (const data of this.brnBnkList) {
        if (data.name == this.ovsesSendBnkRefno) {
          this.showLcalBnkBrnEngName = false;
          return;
        }
      }
      this.showLcalBnkBrnEngName = true;
    },
    popupOpen() {
      this.fillter = true;
      if (this.ovsesSendBnkRefno.length == 0) {
        this.modalOpend = true;
        return;
      }

      this.popupData = {
        ovsesSendBnkRefno: this.ovsesSendBnkRefno,
        bnkShtenName: this.lcalBnkBrnEngName,
        bnkEngName: this.bnkEngName,
        inquryAcno: this.inquryAcno,
      };

      this.lcalBnkBrnNo = this.$getBnkBrnNo().MM2.getBranchNo(this.ovsesSendBnkRefno, this.inquryAcno);

      this.searchData = {
        ovsesSendBnkRefno: this.ovsesSendBnkRefno, //해외송신은행참조번호
        bnkEngName: this.bnkEngName, //은행영문명
        lcalBnkBrnNo: this.lcalBnkBrnNo, //현지은행부점번호
        tranDstCd: "BNKNO",
      };
      if (this.ovsesSendBnkRefno.length > 0) {
        this.popupRBF0408W40Call();
      }
      if (!this.lcalBnkBrnNo.length > 0) {
        this.popupShow = true;
        this.showGrid = true;
        this.searchWord = "";
      }
      // if (this.lcalBnkBrnNo.length > 0) {
      //   this.openSheet = true;
      // } else {
      //   this.popupShow = true;
      //   this.showGrid = true;
      // }
    },
    popupClose(data) {
      if (data != null) {
        this.lcalBnkAcnoInfo = {
          ovsesSendBnkNo: data.ovsesSendBnkNo,
          ovsesSendBnkRefno: data.ovsesSendBnkRefno,
          bnkShtenName: data.bnkShtenName,
          bnkEngName: data.bnkEngName,
          lcalBnkBrnNo: data.lcalBnkBrnNo,
          lcalBnkBrnEngName: data.lcalBnkBrnEngName,
          inquryAcno: this.inquryAcno,
        };
        this.sheetLcalBnkBrnEngName = data.lcalBnkBrnEngName;
        this.lcalBnkBrnEngName = data.lcalBnkBrnEngName;
      }
      this.searchWord = "";
      this.popupShow = false;
      this.showGrid = false;
    },
    confirm() {
      if (this.showLcalBnkBrnEngName == false) {
        this.lcalBnkAcnoInfo = {
          ovsesSendBnkNo: this.popupRBF0408W40.response.grid[0].ovsesSendBnkNo,
          ovsesSendBnkRefno: this.popupRBF0408W40.response.grid[0].ovsesSendBnkRefno,
          bnkShtenName: this.popupRBF0408W40.response.grid[0].bnkShtenName,
          bnkEngName: this.popupRBF0408W40.response.grid[0].bnkEngName,
          lcalBnkBrnNo: this.popupRBF0408W40.response.grid[0].lcalBnkBrnNo,
          lcalBnkBrnEngName: this.popupRBF0408W40.response.grid[0].lcalBnkBrnEngName,
          inquryAcno: this.inquryAcno,
        };
        this.lcalBnkBrnEngName = this.popupRBF0408W40.response.grid[0].lcalBnkBrnEngName;
      }
      this.RBF0600C60Call();
      this.openSheet = !this.openSheet;
    },
    cancel() {
      this.lcalBnkAcnoInfo = {
        //ovsesSendBnkNo: this.popupRBF0408W40.response.grid[0].ovsesSendBnkNo,
        // ovsesSendBnkRefno: this.popupRBF0408W40.response.grid[0].ovsesSendBnkRefno,
        ovsesSendBnkNo: "",
        ovsesSendBnkRefno: "",
        //bnkShtenName: this.popupRBF0408W40.response.grid[0].bnkShtenName,
        //bnkEngName: this.popupRBF0408W40.response.grid[0].bnkEngName,
        //lcalBnkBrnNo: this.popupRBF0408W40.response.grid[0].lcalBnkBrnNo,
        //lcalBnkBrnEngName: this.popupRBF0408W40.response.grid[0].lcalBnkBrnEngName,
        inquryAcno: this.inquryAcno,
      };
      this.lcalBnkBrnEngName = "";
      this.openSheet = !this.openSheet;
    },

    popupRBF0408W40Call(type) {
      if (this.call) {
        if (type == "tag" || type == "addSearch") {
          this.searchType = type;
          this.page = 1;
        } else if (type == "scroll") {
          this.searchType = type;
          this.page++;
        } else {
          this.searchType = "searchBox";
          this.page = 1;
        }
        this.call = false;
        //this.page = 1;
        this.popupRBF0408W40.request = {
          dmndPageNo: this.page, //요청페이지번호(입력부)
          pageLineCnt: "500", //페이지라인수(입력부)
          tranDstCd: "BNKNO",
          ...this.searchData,
        };

        this.$post("/customer/acn/LocalBnkListInquiry", this.popupRBF0408W40.request, this.popupRBF0408W40Suc);
      }
    },
    otrbnkRBF0408W40Call() {
      this.popupRBF0408W40.request = {
        dmndPageNo: this.page, //요청페이지번호(입력부)
        pageLineCnt: "500", //페이지라인수(입력부)
        tranDstCd: "BNKNO",
        ...this.searchData,
      };

      return new Promise(resolve => {
        this.$post("/customer/acn/LocalBnkListInquiry", this.popupRBF0408W40.request, response => {
          this.popupRBF0408W40.response = response.outItem;
          if (_.isEmpty(this.popupRBF0408W40.response.grid)) {
            this.lcalBnkAcnoInfo.ovsesSendBnkNo = "";
          } else if (!this.showLcalBnkBrnEngName) {
            this.lcalBnkBrnNo = this.popupRBF0408W40.response.grid[0].lcalBnkBrnNo;
            this.sheetLcalBnkBrnEngName = this.popupRBF0408W40.response.grid[0].lcalBnkBrnEngName;
            this.lcalBnkAcnoInfo.ovsesSendBnkNo = this.popupRBF0408W40.response.grid[0].ovsesSendBnkNo;
            this.lcalBnkBrnEngName = this.popupRBF0408W40.response.grid[0].lcalBnkBrnEngName;
          }
          if (_.isEmpty(this.popupRBF0408W40.response.grid)) {
            resolve(this.popupRBF0408W40.response);
          } else {
            resolve(this.popupRBF0408W40.response.grid[0].lcalBnkBrnNo);
          }
        });
      });
    },
    popupRBF0408W40Suc(res) {
      if (this.searchWord == "") {
        this.popupRBF0408W40.response = res.outItem;
        if (_.isEmpty(this.popupRBF0408W40.response.grid)) {
          this.mmrConfirm = true;
        } else {
          if (this.popupRBF0408W40.response.grid.length > 1) {
            this.dataGrid = [];
            this.dataGrid = this.popupRBF0408W40.response.grid;
            // this.$refs.commonGrid.changeList(this.popupRBF0408W40.response.grid);
            this.$refs.commonGrid2.changeList(this.dataGrid, this.popupRBF0408W40.response.totalLineCnt, this.searchType);
          } else {
            if (this.lcalBnkBrnNo == "" || this.lcalBnkBrnNo == null) {
              this.dataGrid = [];
              this.dataGrid = this.popupRBF0408W40.response.grid;
              //this.$refs.commonGrid.changeList(this.popupRBF0408W40.response.grid);
              this.$refs.commonGrid2.changeList(this.dataGrid, this.popupRBF0408W40.response.totalLineCnt, this.searchType);
            } else {
              this.lcalBnkBrnNo = this.popupRBF0408W40.response.grid[0].lcalBnkBrnNo;
              this.sheetLcalBnkBrnEngName = this.popupRBF0408W40.response.grid[0].lcalBnkBrnEngName;
              this.openSheet = true;
            }
          }
        }
        // if (this.popupRBF0408W40.response.grid.length > 1) {
        //   this.$refs.commonGrid.changeList(this.popupRBF0408W40.response.grid);
        // } else {
        //   if (_.isEmpty(this.popupRBF0408W40.response.grid[0])) {
        //     console.log("fasdf");
        //     this.mmrConfirm = true;
        //   } else {
        //     this.lcalBnkBrnNo = this.popupRBF0408W40.response.grid[0].lcalBnkBrnNo;
        //     this.sheetLcalBnkBrnEngName = this.popupRBF0408W40.response.grid[0].lcalBnkBrnEngName;
        //     this.openSheet = true;
        //   }
        // }
      } else {
        this.popupRBF0408W40.response = res.outItem;
        this.dataGrid = [];
        this.dataGrid = this.popupRBF0408W40.response.grid;
        this.$refs.commonGrid2.changeList(this.dataGrid, this.popupRBF0408W40.response.totalLineCnt, this.searchType);
        //this.$refs.commonGrid.changeList(this.popupRBF0408W40.response.grid);
      }
      this.call = true;
    },
    search() {
      this.fillter = false;
      if (this.checkedRadioValue == "1") {
        this.searchData = {
          lcalBnkBrnEngName: this.searchWord,
          ovsesSendBnkRefno: this.ovsesSendBnkRefno, //해외송신은행참조번호
          bnkEngName: this.bnkEngName, //은행영문명
          lcalBnkBrnNo: "", //현지은행부점번호
          tranDstCd: "BNKNO",
        };
      } else {
        this.searchData = {
          lcalBnkBrnEngName: "",
          ovsesSendBnkRefno: this.ovsesSendBnkRefno, //해외송신은행참조번호
          bnkEngName: this.bnkEngName, //은행영문명
          lcalBnkBrnNo: this.searchWord, //현지은행부점번호
          tranDstCd: "BNKNO",
        };
      }
      this.popupRBF0408W40Call("searchBox");
    },
    async setInfo() {
      if (this.usePage != "manage") {
        this.fillter = true;
        // if (this.ovsesSendBnkRefno.length == 0) {
        //   this.modalOpend = true;
        //   return;
        // }

        // this.popupData = {
        //   ovsesSendBnkRefno: this.ovsesSendBnkRefno,
        //   bnkShtenName: this.lcalBnkBrnEngName,
        //   bnkEngName: this.bnkEngName,
        //   inquryAcno: this.inquryAcno,
        // };

        this.lcalBnkBrnNo = this.$getBnkBrnNo().MM2.getBranchNo(this.ovsesSendBnkRefno, this.inquryAcno);

        this.searchData = {
          ovsesSendBnkRefno: this.ovsesSendBnkRefno, //해외송신은행참조번호
          bnkEngName: this.bnkEngName, //은행영문명
          lcalBnkBrnNo: this.lcalBnkBrnNo, //현지은행부점번호
          tranDstCd: "BNKNO",
        };
        let res = [];
        if (this.ovsesSendBnkRefno.length > 0) {
          res = await this.otrbnkRBF0408W40Call();
        }
        if (!res.length > 0) {
          // this.popupShow = true;
          // this.showGrid = true;
          this.searchWord = "";
        }
        // this.otrbnkNext();
      }
      this.mnrcvInfo = {
        mnrcvAcnAls: "",
        mnrcvAcno: this.inquryAcno,
        mnrcvCncycd: this.sessionInfo.userInfo.baseCncycd,
        mnrcvDpstrName: this.inquryDpstrName,
        mnrcvOthrBnkName: this.bnkEngName,
        mnrcvSerno: "",
        rcevnBnkIfscCode: this.lcalBnkAcnoInfo.ovsesSendBnkNo,
        mnrcvBrnName: this.lcalBnkBrnEngName,
      };
      return this.mnrcvInfo;
    },
    goToPrev() {
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    RBF0408W40Call() {
      this.RBF0408W40.request = {
        tranDstCd: "REFNO", //거래구분코드(참조번호조회)
      };
      this.$post("/customer/acn/LocalBnkRefNoListInquiry", this.RBF0408W40.request, this.RBF0408W40Suc);
    },
    RBF0408W40Suc(res) {
      this.RBF0408W40.response = res.outItem; //ovsesSendBnkRefNo : bnkEngName
      let tempArry = [];
      for (const data of res.outItem.grid) {
        tempArry.push({ text: data.bnkShtenName + " (" + data.bnkEngName + ")", value: data.ovsesSendBnkRefno, data: data.bnkEngName });
      }
      this.bankList = tempArry;
    },
    scrollEvent() {
      if (this.popupRBF0408W40.response.gridRowCnt < 10 && this.popupRBF0408W40.response.totalLineCnt != 0) {
        return;
      } else if (this.page * this.popupRBF0408W40.response.gridRowCnt == this.popupRBF0408W40.response.totalLineCnt) {
        return;
      } else {
        // this.scrollSearch();
        this.popupRBF0408W40Call("scroll");
      }
    },
    // scrollSearch() {
    //   if (this.call) {
    //     this.page = this.page++;
    //     this.call = false;
    //     this.popupRBF0408W40.request = {
    //       dmndPageNo: this.page, //요청페이지번호(입력부)
    //       pageLineCnt: "10", //페이지라인수(입력부)
    //       tranDstCd: "BNKNO",
    //       ...this.searchData,
    //     };

    //     this.$post("/customer/acn/LocalBnkListInquiry", this.popupRBF0408W40.request, this.scrollSearchSuc);
    //   }
    // },
    // scrollSearchSuc(res) {
    //   this.dataGrid = res.outItem.grid;
    //   if (!_.isEmpty(this.dataGrid)) this.popupRBF0408W40.response.grid = [...this.popupRBF0408W40.response.grid, ...this.dataGrid];
    //   this.$refs.commonGrid.changeList(this.popupRBF0408W40.response.grid);
    //   this.call = true;
    // },
    valid() {
      if (this.showLcalBnkBrnEngName == true) {
        if (this.lcalBnkBrnEngName == "") {
          this.lcalBnkBrnEngNameVal = true;
        } else {
          this.lcalBnkBrnEngNameVal = false;
        }
        if (this.usePage == "manage") {
          this.$refs.inquryAcnAls.$v.$touch();
        }
        this.$refs.inquryAcno.$v.$touch();
        this.$refs.inquryDpstrName.$v.$touch();
        this.$refs.ovsesSendBnkRefno.$v.$touch();
        if (this.usePage == "manage") {
          if (
            this.$refs.inquryAcno.$v.$invalid ||
            this.$refs.inquryAcnAls.$v.$invalid ||
            this.$refs.inquryDpstrName.$v.$invalid ||
            this.$refs.ovsesSendBnkRefno.$v.$invalid ||
            this.lcalBnkBrnEngNameVal
          ) {
            return false;
          }
          return true;
        } else {
          if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.ovsesSendBnkRefno.$v.$invalid || this.lcalBnkBrnEngNameVal) {
            return false;
          }
          return true;
        }
      } else {
        if (this.lcalBnkBrnEngName == "") {
          this.lcalBnkBrnEngNameVal = true;
        } else {
          this.lcalBnkBrnEngNameVal = false;
        }
        if (this.usePage == "manage") {
          this.$refs.inquryAcnAls.$v.$touch();
        }
        this.$refs.inquryAcno.$v.$touch();
        this.$refs.inquryDpstrName.$v.$touch();
        this.$refs.ovsesSendBnkRefno.$v.$touch();
        if (this.usePage == "manage") {
          if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryAcnAls.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.ovsesSendBnkRefno.$v.$invalid) {
            return false;
          }
          return true;
        } else {
          if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.ovsesSendBnkRefno.$v.$invalid) {
            return false;
          }
          return true;
        }
      }
    },
    goToNext() {
      // this.$refs.inquryAcnAls.$v.$touch();
      // this.$refs.inquryAcno.$v.$touch();
      // this.$refs.inquryDpstrName.$v.$touch();
      // this.$refs.ovsesSendBnkRefno.$v.$touch();
      // if (
      //   this.$refs.inquryAcno.$v.$invalid ||
      //   this.$refs.inquryAcnAls.$v.$invalid ||
      //   this.$refs.inquryDpstrName.$v.$invalid ||
      //   this.$refs.ovsesSendBnkRefno.$v.$invalid ||
      //   this.lcalBnkBrnEngNameVal
      // ) {
      //   return;
      // }
      if (this.valid()) {
        if (this.showLcalBnkBrnEngName == true) {
          // this.RBF0600C60Call();
          this.openSheet = true;
        } else {
          this.popupOpen();
        }
      }
    },
    RBF0600C60Call() {
      this.RBF0600C60.request = {
        dmndPageNo: "00000",
        pageLineCnt: "00000",
        gridRowCnt: "00001",
        inquiryUserStupAcnDstcd1: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
        deviceType: "mobile",
        inDataGrid: [
          {
            inquryUserStupAcnDstcd2: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
            inquryAcno: this.inquryAcno, // 계좌번호
            inqurySerno: "1", // 일련번호
            inquryBrncoEcrypPwd: "", // 계좌비밀번호
            inquryAcnAls: this.inquryAcnAls, // 계좌별명
            inquryDpstrName: this.inquryDpstrName, // 예금주명
            inquryOthrBnkName: this.bnkEngName, // 타은행명
            inquryBrnName: this.lcalBnkBrnEngName, // 부점명
            inquryCncycd: this.cncycd, //통화코드
            inquryPrcssDstcd: "2", // 처리구분코드 1:출금계좌등록, 2:입금계좌등록, 5:계좌번호변경, 6:계좌번호해지
            inquryObaobDstcd: "2", // 당타행구분코드 1:당행, 2:타행
            draweAcitmDstcd: "01",
            rcevnBnkIfscCode: this.lcalBnkAcnoInfo.ovsesSendBnkNo,
          },
        ],
      };

      this.$post(
        "/customer/acn/MnrcyAcnRegiRes",
        this.RBF0600C60.request, //input값 요청할데이터
        this.RBF0600C60Suc, //호출 성공시 실행하는 콜백
      );
    },
    /* API_RBF0600C60 호출 성공 */
    RBF0600C60Suc(res) {
      this.RBF0600C60.response = res.outItem;
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    otrbnkNext() {},
  },
};
</script>
